<template>
  <div class="modal-backdrop">
    <div class="popup-content tracker-popup">
      <h3>
        Добро пожаловать в режим обучения!
      </h3>
      <p>
        Здесь вы можете безопасно изучить все возможности Навигатора эмоций в своем темпе. Потренируйтесь с инструментом и экспериментируйте без риска — ваши действия не повлияют на аналитику. Когда будете готовы, переключитесь в режим работы, чтобы начать применять инструмент в ежедневной практике.
      </p>
      <div class="button-wrapper">
        <button @click="$emit('close')" class="btn btn-accent study-button">
          Приступить к обучению
          <span>
            <img src="@/assets/images/mood_tracker/graduate-cap-1.svg" width="25px" alt="Иконка">
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-content.tracker-popup {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  width: 60%;
  max-width: 650px;
  min-height: 250px;
  background-color: white;
  border-radius: 16px;

  h3 {
    text-align: center;
    font-size: 26px;
  }

  button {
    border-radius: 16px;
  }

  .study-button {
    display: flex;
    gap: 8px;
    align-items: center;
    margin: auto;
    font-weight: 600;
  }

  @media (max-width: 1024px) {
    width: 90%;
  }
}
</style>